import React, { Component } from 'react';
import moment from 'moment';
import { vehicles } from '../../../../utils/api';
import SuggestionsBlockUI from './SuggestionsBlockUI';
import './index.scss';

class PriceSuggestionsBlock extends Component {
  state = {
    isLoading: true,
    data: []
  };

  componentDidMount() {
    this.getSuggestions();
  }

  componentDidUpdate(prevProps) {
    const { vehicleId } = this.props;
    const { vehicleId: prevVehicleId } = prevProps;

    if (vehicleId !== prevVehicleId) {
      this.getSuggestions();
    }
  }

  getSuggestions() {
    const { vehicleId } = this.props;
    return vehicles.getSuggestions(vehicleId).then(res => {
      this.setState({
        data: res.data.data.filter(item => {
          try {
            const currentTime = moment.utc();
            const isVehicleTimerEnded =
              item.end_time_spacing !== null &&
              moment(item.auction.date_end)
                .utc()
                .add(item.end_time_spacing, 'seconds')
                .isBefore(currentTime);
            return !isVehicleTimerEnded;
          } catch (error) {
            return true;
          }
        }),
        isLoading: false
      });
    });
  }

  render() {
    const { data, isLoading } = this.state;
    return (
      <SuggestionsBlockUI pivotIndex={0} pivotIndexMobile={0} data={data} isLoading={isLoading} blockTitle="Cars in similar price range" />
    );
  }
}

export default PriceSuggestionsBlock;
